import { DynamicShiftStatus } from '@bemlo/enums'

import { IconName } from '../Icon'

const STATUS_ICON_MAP: Record<DynamicShiftStatus, IconName | null> = {
  [DynamicShiftStatus.APPLICATION_NOT_CHOSEN]: 'XCircleIcon',
  [DynamicShiftStatus.APPLIED]: 'ReplyIcon',
  [DynamicShiftStatus.SUGGESTED]: 'LightBulbIcon',
  [DynamicShiftStatus.ACCEPTED]: null,
  [DynamicShiftStatus.AVAILABLE]: null,
  [DynamicShiftStatus.BOOKED]: 'CheckCircleIcon',
  [DynamicShiftStatus.CANCELED]: 'XCircleIcon',
  [DynamicShiftStatus.OCCUPIED]: 'XCircleIcon',
  [DynamicShiftStatus.REJECTED]: 'ReplyIcon',
  [DynamicShiftStatus.WITHDRAWN]: null,
}

export const useShiftStatusIconName = (
  status: DynamicShiftStatus,
  isUrgent: boolean,
): IconName | null => {
  return status === DynamicShiftStatus.AVAILABLE && isUrgent
    ? 'ExclamationIcon'
    : STATUS_ICON_MAP[status]
}
